import { useEffect, useState } from 'react'
import { Dropdown, Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Card from '../../components/Card'
import CustomToggle from '../../components/dropdowns'
import "react-responsive-carousel/lib/styles/carousel.min.css"
//image
import user01 from '../../assets/images/user/01.jpg'
import axios from 'axios'
import toast, { Toaster } from 'react-hot-toast';
import { getToken } from '../../utils/auth'
import { useNavigate } from 'react-router-dom'
import * as moment from 'moment'
import CarouselN from 'react-bootstrap/Carousel'

const LostCardBody = ({ data, index }) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!getToken()) {
            navigate("/auth/sign-in")
        }
    }, []);
    const [content, setContent] = useState(null);
    const [comments, setComments] = useState(null);
    const [show, setShow] = useState(null);
    const [qrPopupOpen, setQrPopupOpen] = useState(false);
    const [qrImageUrl, setQrImageUrl] = useState('');

    const handleQrClick = (imageUrl) => {
        setQrImageUrl(imageUrl);
        setQrPopupOpen(true);
    };

    const closeQrPopup = () => {
        setQrPopupOpen(false);
    };

    useEffect(() => {
        handleGetComments();
    }, [])
    const handleGetComments = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/device/comment/${data?._id}`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            }
            )
            setComments(response?.data?.data);
        } catch (error) {
            console.log("Failed Fetching Devices", error);
        }
    }
    const handleChange = (e, index) => {
        setContent(e.target.value)
    }

    const handleAddComments = async (e, id) => {
        e.preventDefault();
        try {

            const dataToSent = {
                "content": content,
                "attachmentLink": ''
            }
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/device/comment/${id}`,
                dataToSent, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
            );
            // toast.success(response?.data?.message);
            setContent('');
            handleGetComments(id);
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }

    const handleSavePost = async (LostID) => {
        try {
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/device/save/${LostID}`, {}, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    // "Content-Type": "multipart/form-data"
                }
            }
            )
            toast.success(response.data.message)
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed Saving Post");
        }
    }
    return (
        <>
<Toaster position="top-right" reverseOrder={false}/>
<Card.Body>
               
                <div className="user-post-data">
                    <div className="d-flex justify-content-between">
                        <div className="me-3">
                            <img className="rounded-circle img-fluid" src={data?.userId?.profileImageLink ? data?.userId?.profileImageLink : '/profile.png'} alt="" style={{ width: "55px", height: "50px" }} />
                        </div>
                        <div className="w-100">
                            <div className="d-flex justify-content-between">
                                <div>
                                    <h5 className="mb-0 d-inline-block">{data?.userId?.firstName} {data?.userId?.lastName}</h5>
                                    <span className="mb-0 ps-1 d-inline-block">has lost item</span>
                                    <p className="mb-0 text-primary">{moment(data?.createdAt).fromNow()}</p>
                                </div>
                                <div className="card-post-toolbar" style={{ display: "flex" }}>
                                    {data?.qrcId?.qrCodeUrl ? (<div>
                                        <img src={data?.qrcId?.qrCodeUrl}
                                            onClick={() => handleQrClick(data?.qrcId?.qrCodeUrl)}
                                            style={{
                                                width: "50px",
                                                height: "50px",

                                            }} />



                                    </div>) : (
                                        <div>
                                        </div>
                                    )}
                                    <Dropdown>
                                        <Dropdown.Toggle variant="bg-transparent">
                                            <span className="material-symbols-outlined">
                                                more_horiz
                                            </span>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="dropdown-menu m-0 p-0">
                                            <Dropdown.Item className=" p-3" to="#" onClick={() => handleSavePost(data._id)}>
                                                <div className="d-flex align-items-top">
                                                    <div className="h4 material-symbols-outlined">
                                                        <i className="ri-save-line"></i>
                                                    </div>
                                                    <div className="data ms-2">
                                                        <h6>Save Lost Item</h6>
                                                        <p className="mb-0">Add this to your saved items</p>
                                                    </div>
                                                </div>
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="me-3">
                            <h3>{data?.itemName}</h3>
                        </div>

                    </div>
                </div>
                {/* <div className="d-grid grid-rows-2 grid-flow-col gap-3 ">
                                                {
                                                    data?.devicePhotos?.map((img, idx) =>
                                                        <div className={`${idx === 0 ? 'row-span-2 row-span-md-1' : 'row-span-1'}`} key={idx}>
                                                            <img src={img} alt="device img" className="img-fluid rounded w-100" />
                                                        </div>
                                                    )
                                                }
                                            </div> */}
                <div className="user-post">
                    <CarouselN style={{ maxWidth: '600px', margin: '0 auto' }}>
                        {data?.devicePhotos?.map((photo, photoIndex) => (
                            <CarouselN.Item key={photoIndex}>
                                <img
                                    className="d-block w-100"
                                    src={photo}
                                    alt={`post-photo-${photoIndex}`}
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                    }}
                                />
                            </CarouselN.Item>
                        ))}
                    </CarouselN>
                </div>
                {/* <div className="d-flex flex-wrap gap-3 ">
                    {
                        data?.devicePhotos?.map((img, idx) =>
                            <div className={``} key={idx}>
                                <img src={img} alt="device img" style={{ width: "240px", height: "240px" }} className="img-fluid rounded " />
                            </div>
                        )
                    }
                </div> */}
                <div className="comment-area mt-3">
                    <div className="total-comment-block">
                        <Dropdown>
                            <Dropdown.Toggle as={CustomToggle} >
                                {comments?.allComments.length} Comments
                            </Dropdown.Toggle>

                        </Dropdown>
                    </div>

                    <hr />
                    <ul className="post-comments p-0 m-0">
                        {
                            comments?.allComments?.slice(0, 3).map((i) =>
                                <li className="mb-2">
                                    <div className="d-flex">
                                        <div className="user-img">
                                            <img src={i?.author?.profileImageLink ? i?.author?.profileImageLink : "/profile.png"} alt="userimg" className="avatar-35 rounded-circle img-fluid" />
                                        </div>
                                        <div className="comment-data-block ms-3">
                                            <h6>{i?.author?.firstName} {i?.author?.lastName}</h6>
                                            <p className="mb-0">{i?.content}</p>
                                            <div className="d-flex flex-wrap align-items-center comment-activity">

                                                <span> {moment(i?.timestamp).fromNow()} </span>
                                            </div>
                                        </div>
                                    </div>

                                </li>
                            )
                        }
                        {
                            show === index &&
                            comments?.allComments?.slice(3, 1000000).map((i) =>
                                <li className="mb-2">
                                    <div className="d-flex">
                                        <div className="user-img">
                                            <img src={i?.author?.profileImageLink ? i?.author?.profileImageLink : "/profile.png"} alt="userimg" className="avatar-35 rounded-circle img-fluid" />
                                        </div>
                                        <div className="comment-data-block ms-3">
                                            <h6>{i?.author?.firstName} {i?.author?.lastName}</h6>
                                            <p className="mb-0">{i?.content}</p>
                                            <div className="d-flex flex-wrap align-items-center comment-activity">
                                                <Link to="">like</Link>
                                                <Link to="">reply</Link>
                                                <Link to="">translate</Link>
                                                <span> {moment(i?.timestamp).fromNow()} </span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            )

                        }
                        <button className='bg-white border-0 ' onClick={() => { setShow(show === index ? null : index) }}>{comments?.allComments?.length > 3 && (show === index ? 'Show Less' : 'Show More')}</button>
                    </ul>
                    <form className="comment-text d-flex align-items-center mt-3" action="" onSubmit={(e) => handleAddComments(e, data?._id)}>
                        <input type="text"
                            className="form-control rounded"
                            placeholder="Enter Your Comment"
                            value={content}
                            onChange={(e) => handleChange(e)}
                        />

                        {/* <label
                                htmlFor="file-input"
                                style={{ cursor: "pointer"}}
                                className='comment-attagement'
                            >

                                <input
                                    id="file-input"
                                    type="file"
                                    name="image"
                                    accept="image/*"
                                    multiple
                                    style={{ display: "none" }}
                                    onChange={handleFileInputChange}
                                />

                                    <i className="ri-link me-3"></i>

                            </label> */}
                    </form>
                    {/* <div className="d-flex gap-3 ">
                                    {
                                        links &&
                                        <img src={links} style={{ width: "40px", height: "40px" }} className="rounded" alt="img" />
                                    }
                                </div> */}
                </div>
                <Modal size="md" className="fade" id="qr-modal" onHide={closeQrPopup} show={qrPopupOpen} centered >
                    <Modal.Header closeButton>
                        <Modal.Title>QR Code</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center pb-5">
                        <img src={qrImageUrl} alt="QR Code" style={{ maxWidth: '100%', height: 'auto' }} />
                    </Modal.Body>
                </Modal>

            </Card.Body>
        </>
    )
}

export default LostCardBody
